import React from "react";
import styles from "./DefaultButton.module.css";


const DefaultButton = ({ onClick, children, type, size }) => {
  if (type == 'disabled') {
    onClick = null
  }
  return (
    <button
      className={`
          ${styles.btn} 
          ${styles[type]}
          ${styles[size]}
          ${styles[type] == 'disabled' ? styles.disabled : ''}
        `}
      onClick={onClick}>
      {children}
    </button>
  );
};
export default DefaultButton;
